module.exports = __webpack_public_path__ + "static/media/color.f1438b0e.svg";